export const theme = {
    colors: {
        groups: {
            blue: {
                primary: {
                    v10: '#E5F1F8',
                    v25: '#BFDEEF',
                    v50: '#80BDE0',
                    v75: '#409CD1',
                    v100: '#007cc2',
                },
                dark: {
                    v10: '#E5E7EC',
                    v25: '#BFC4D0',
                    v50: '#818AA2',
                    v75: '#424F73',
                    v100: '#031545',
                },
                ice: {
                    v10: '#71C5E8',
                    v25: '#94D3ED',
                    v50: '#B8E2F3',
                    v75: '#94D3ED',
                    v100: '#71C5E8',
                },
            },
            achromatic: {
                black: '#000',
                storm: '#575757',
                rain: '#B7B7B7',
                lightSilver: '#d8d8d8',
                cloud: '#e7e7e7',
                fog: '#F7F7F7',
                white: '#fff',
            },
            brand: {
                coral: {
                    v25: '#FDD7DD',
                    v50: '#FCAFBC',
                    v75: '#FB879A',
                    v100: '#FA6079',
                },
                green: {
                    v25: '#D3ECE0',
                    v50: '#A9DAC2',
                    v75: '#7EC7A3',
                    v100: '#53B585',
                },
                orange: {
                    v25: '#FCE8D4',
                    v50: '#FAD3A9',
                    v75: '#F8BD7E',
                    v100: '#F6A754',
                },
                purple: {
                    v25: '#D8D2E2',
                    v50: '#B2A7C7',
                    v75: '#8B7BAB',
                    v100: '#654F8F',
                },
                teal: {
                    v25: '#D1F0EE',
                    v50: '#A4E2DD',
                    v75: '#77D3CC',
                    v100: '#4AC5BC',
                },
            },
            digital: {
                pink: {
                    v5: '#FDF2F6',
                    v100: '#E0004D',
                },
                orange: {
                    v5: '#FFFBF3',
                    v100: '#FFBB13',
                },
                green: {
                    v5: '#F4F9F4',
                    v100: '#29822F',
                },
            },
        },
        white: '#fff',
        black: '#000',
        storm: '#575757',
        rain: '#B7B7B7',
        lightSilver: '#d8d8d8',
        cloud: '#e7e7e7',
        fog: '#F7F7F7',
        blue: '#007cc2',
        darkBlue: '#01639b',
        lightBlue: '#3396CE',
        borderColor: '#dedede',
        lightWhite: '#f9f9f9',
        darkBlue75: '#424F73',
        darkBlue100: '#031545',
        green: '#29822f',
        red: '#e0004d',
        lightGrey: '#979797',
        darkGrey: '#575757',
    },
    constants: {
        headerHeight: '74px',
        shrinkedHeaderHeight: '50px',
        sidebarWidth: '320px',
        layoutBreakpoint: '960px',
        xl: '1400px',
        lg: '1100px',
        md: '800px',
        sm: '500px',
        xs: '0px',
    },
    fontWeight: {
        light: 100,
        normal: 300,
        bold: 500,
        bolder: 700,
    },
};
